import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import ReduxSagaFirebase from 'redux-saga-firebase'

const config = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FB_DATABASE_URL,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BACKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSANGING_SENDER_ID
}

const myFirebaseApp = firebase.initializeApp(config)

const firestore = firebase.firestore()

const rsf = new ReduxSagaFirebase(myFirebaseApp)

export {
  firestore,
  firebase,
  rsf
}



// WEBPACK FOOTER //
// ./src/firebase.js